import $ from 'jquery';
import {shuffleArray} from "../playUtil.es6";
import PlayAudio from "../memo/playAudio.es6";
import {arrayContainsP, arrayRandomItems} from "../arrayUtil.es6";

require('jsrender')($);

const SET_TMPL = $.templates(`
<div class="pack-test-set">
    <div class="pack-test-set__title">{{>~l18n.get('packTest.qsChoice')}}</div>
    <div class="pack-test-set__choice">
        <div class="pack-test-set__choice-questions">
            <ul class="mb-3">
            {{for questions}}
                <li class="row no-gutters pack-test-set__choice-question" data-id="{{:id}}">
                    <div class="col-md-6 row no-gutters mb-3">
                        {{if question.audio}}
                        <div class="col-auto mr-3 pack-test-set__choice-question-audio">
                            <audio src="{{attr:question.audio}}"></audio>
                            <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                        </div>
                        {{/if}}
                        {{if question.image}}
                        <div class="col-auto mr-3 pack-test-set__choice-question-image"><img src="{{attr:question.image}}"/></div>
                        {{/if}}
                        <div class="col pack-test-set__choice-question-text fl-tt-{{:question.textType}}">{{if question.textType == 'html'}}{{:question.text}}{{else}}{{> question.text}}{{/if}}</div>
                    </div>
                    <ul class="col-md-6 pack-test-set__choice-answers">
                        {{for answers ~question=#data}}
                        <li class="mb-3">
                               <div class="custom-control custom-radio custom-control-inline">
                                    <input class="custom-control-input" id="choice_answer_{{:~question.id}}_{{:id}}" type="radio" name="choice_answer_{{:~question.id}}" value="{{:id}}">
                                    <label class="custom-control-label" for="choice_answer_{{:~question.id}}_{{:id}}">
                                        <div class="row no-gutters">
                                            {{if audio}}
                                            <div class="col-auto mr-3 pack-test-set__choice-answer-audio">
                                                <audio src="{{attr:audio}}"></audio>
                                                <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                                            </div>
                                            {{/if}}
                                            {{if image}}
                                            <div class="col-auto mr-3 pack-test-set__choice-answer-image"><img src="{{attr:image}}"/></div>
                                            {{/if}}
                                            <div class="col fl-tt-{{:textType}}">{{if textType == 'html'}}{{:text}}{{else}}{{> text}}{{/if}}</div>
                                        </div>
                                    </label>
                                </div>
                        </li>                        
                        {{/for}}
                    </ul>
                </li>
            {{/for}}
            </ul>
        </div>
    </div>
</div>`);

const ANSWER_TMPL = $.templates(`
<span class="pack-test-set__choice-question-expected fl-keep-nl">{{>~l18n.get('packTest.qsChoice.expected')}} {{>expected.textOnly}}.</span>        
`);

export default class TestChoice {
    constructor(props) {
        this.testList = props.testList;
        this.sideAdapter = props.sideAdapter;
        this.l18n = props.l18n;
        this.checkers = props.checkers;
        this.test = props.test;
        this.cards = props.cards;
    }

    create(tasks) {
        const texts = this.sideAdapter;

        const questions = tasks.map(item => {

            let answers = arrayRandomItems(this.cards, 4);
            if (!arrayContainsP(answers, answer => answer.id === item.id)) {
                answers.pop();
                answers.push(item);
            }
            shuffleArray(answers);
            answers = answers.map(answer => texts.answer(answer));
            return {id: item.id, question: texts.question(item), expected: texts.answer(item), answers: answers}
        });
        shuffleArray(questions);

        questions.forEach(q => {
            this.checkers.push(() => {
                const view = this.testList.find(`.pack-test-set__choice-question[data-id=${q.id}]`);
                const viewRadios = view.find(`input[name=choice_answer_${q.id}]`);
                const userAnswer = parseInt(viewRadios.filter(':checked').val());
                if (userAnswer === q.id) {
                    view.addClass('pack-test-set__choice-question--correct');
                    this.test.correctAnswers += 1;
                } else {
                    view.addClass('pack-test-set__choice-question--wrong');
                    view.append(ANSWER_TMPL.render(q, this));
                }

                viewRadios.each(function () {
                    const radio = $(this), radioValue = parseInt(radio.attr('value'));
                    if (radioValue === userAnswer) {
                        if (radioValue === q.id) {
                            radio.closest('.custom-radio').addClass('custom-radio-correct');
                        } else {
                            radio.closest('.custom-radio').addClass('custom-radio-wrong');
                        }
                    } else {
                        radio.closest('li').remove();
                    }
                });

                // disable user click on label
                viewRadios.remove();
            });
        });

        const html = $(SET_TMPL.render({questions: questions}, this));

        html.find('a[data-handler=playAudio]').each(function (e) {
            const anchor = $(this);
            PlayAudio.initSingleSide(anchor, false, anchor.closest('div'));
        });

        this.testList.append(html);
    }
}